import * as React from "react";
import {formatDate1}        from "@Common/ui-components/format-date";
import {leadColumns}        from "../analytics-leads";
import {xdQAAttribute}      from "../../analytics-layout";
import "./analytics-lead-card.scss";

export const AnalyticsLeadCard = ({
    modulus,
    acceptLeads,
    interaction,
    setLeadInfo,
    leadsSelected, setLeadsSelected
}) => {
    const backgroundColor = modulus == 0 ? 'light' : 'dark'
    const isSelected = leadsSelected.includes(interaction?.idLead)

    return (
        <div
            className={`analytics-card ${isSelected ? 'selected' : backgroundColor}`}
            onClick={(e) => {
                e.stopPropagation()
                setLeadInfo(interaction)
                acceptLeads(interaction.idLead)
            }}
            {...xdQAAttribute('card', interaction?.['name'])}
        >
            <div
                className="analytics-card-toggle-selected"
                onClick={(e) => e.stopPropagation()}
            >
                <input
                    className={`checkbox ${isSelected ? 'selected' : ''}`}
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                        e.stopPropagation()
                        if(isSelected) {
                            setLeadsSelected(
                                leadsSelected.filter(interactionKey =>
                                    interactionKey !== interaction?.idLead
                                )
                            )
                            return
                        }
                        setLeadsSelected([
                            ...leadsSelected,
                            interaction?.idLead
                        ])
                    }}
                    {...xdQAAttribute('checkbox', 'select lead')}
                />
            </div>
            {
                leadColumns.map((leadColumn, j) => {
                    return (
                        <LeadColumnDatum
                            key={j}
                            interaction={interaction}
                            leadColumn={leadColumn}
                        />
                    )
                })
            }
        </div>
    )
}

const LeadColumnDatum = ({interaction, leadColumn}) => {
    const hasUnaccepted = interaction?.typeUnaccepted?.length > 0 ?? false
    const isUnaccepted = interaction?.typeUnaccepted?.find((interactionKey) => interactionKey === leadColumn.interactionKey)

    let text = interaction?.[leadColumn.interactionKey]
    let classNames = `column${(hasUnaccepted || isUnaccepted) ? ' unaccepted' : ''}`
    switch(leadColumn.interactionKey) {
        case 'name':
            text = titleCase(interaction?.['name'])
            classNames = `column name${hasUnaccepted ? ' unaccepted pip' : ' accepted'}`
            break
        case 'date':
            text = formatDate1(new Date(interaction?.['date']))
            break
        default:
            break
    }

    return (
        <div
            className={classNames}
            {...xdQAAttribute('label', leadColumn.interactionKey)}
        >
            {text}
        </div>
    )
}

export const titleCase = (text) => {
    if(!text) {
        return ''
    }
    const words = text.split(" ")
    let title = ""
    for(let i = 0; i < words.length; i++) {
        title += words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase() + " "
    }
    return title.trim()
}